import { zEmailRequired, zSNOptionalNullable, zStringRequired } from '@/general/src/other/validation.js'
import { z } from 'zod'

export const zSignInAgentEndpointInput = z.object({
  email: zEmailRequired,
  password: zStringRequired,
  organizationSn: zSNOptionalNullable,
  appType: z.enum(['webapp', 'desktopapp']),
})
